import { css } from 'emotion';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import { animationTransition } from '@joykit/variables';

export namespace styles {
  export const container = css({
    width: 1020,
    maxWidth: '90vw',
    margin: '0 auto',
    marginTop: 16
  });

  export const listContainer = css({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'center'
  });

  export const listItem = css({
    display: 'inline-block',
    ':not(:last-child)': {
      marginRight: 16
    }
  });

  export const navLink = css({
    color: '#333',
    cursor: 'pointer',
    padding: 10,
    ...getInterUIDynamicMetricCssObject(15),
    transition: animationTransition('color'),
    '&.active': {
      cursor: 'default'
    },
    ':hover': {
      color: '#e8b0b3'
    }
  });

  export const svg = css({
    marginRight: 8,
    ' svg': {
      height: 14
    }
  });

  export const navButton = css({
    padding: '8px 16px',
    textDecoration: 'none',
    color: '#333',
    border: '1px solid #ebebeb',
    borderRadius: '5px',
    transition: animationTransition('border-color', 'background-color'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':hover': {
      backgroundColor: '#b5b2c4',
      borderColor: '#b5b2c4'
    }
  });

  export const featureIcon = (icon: string) =>
    css({
      backgroundImage: `url('${icon}')`,
      margin: '0 auto',
      marginBottom: '10px',
      width: '48px',
      height: '48px'
    });

  export const featureList = css({
    display: 'flex',
    justifyContent: 'space-evenly',
    listStyleType: 'none'
  });

  export const featureListContainer = (featuresIsOpen: boolean) =>
    css(
      {
        backgroundColor: '#F9F9FB',
        overflowY: 'hidden',
        padding: 0,
        transitionProperty: 'all',
        transitionDuration: '.5s',
        transitionTimingFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)'
      },
      featuresIsOpen
        ? {
            maxHeight: 129,
            padding: 28
          }
        : {
            maxHeight: 0
          }
    );

  export const featureLink = css({
    textDecoration: 'none',
    color: '#333',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    justifyContent: 'center'
  });

  export const featureContainer = css({
    padding: '0 10px',
    margin: '0 auto',
    '@media (min-width: 768px)': {
      width: 740
    },
    '@media (min-width: 992px)': {
      width: 880
    },
    '@media (min-width: 1200px)': {
      width: 1020
    }
  });

  export const carrotContainer = css({
    display: 'flex',
    alignItems: 'center'
  });

  export const chevron = (open: boolean) =>
    css({
      height: 12,
      width: 12,
      marginLeft: 8,
      transform: open ? 'rotate(180deg)' : undefined,
      transition: animationTransition('transform')
    });
}
